// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"231":"a8547f17","270":"076c4396","525":"8b3585f0"}[chunkId] + ".chunk.css";
};